let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hLGQ6")).then(() => parcelRequire('3cv2S'));